import { Expose } from 'class-transformer'

export class BookRatingType {
  @Expose() id: number

  @Expose() name: string
}
